<template>
  <div>
    <div class="Otxt" v-show="!editMode"><div v-html="card.description_text"></div><div class="EditTxtBt Edit" v-if="showEditLink" @click="toggleEditMode"></div></div>
    <div class="Otxtl" v-show="editMode">
      <Wysiwyg
        :content="card.description_text"
        :saveData="updateDescriptionText"
        class="OtxtE"
      ></Wysiwyg>
    </div>
  </div>
</template>

<script>
import Wysiwyg from "@/components/Wysiwyg.vue";

export default {
  components: {
    Wysiwyg
  },
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function,
  },
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      console.log('Card component toggleEditMode', this.editMode);
    },
    updateDescriptionText(value) {
      // const params = {description_text: this.editor.getHTML()};
      const params = {description_text: value};
      this.saveData({card: params}, this.toggleEditMode, ['description_text']);
    }
  },
};
</script>
